import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { notification } from "antd";

export const useCreateDocumentContent = () => {
  const queryClient = useQueryClient();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => DocumentContentService.create(body),
  });

  const createDocumentContent = (
    body: any,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(body, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["document-content"],
        });
        window.location.hash = `title-${response.Id}`;
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Thêm thất bại.`,
        });
      },
    });
  };

  return { mutate, createDocumentContent, ...restMutation };
};
